import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

import { ClickOutsideModule } from 'ng-click-outside';

import { MiscModule } from '../../Common/Misc/misc.module';

import { CoreDialogService } from './services/dialog.service';
import { DialogContainerComponent } from './components/DialogContainer/dialog-container.component';
import { LocalizationModule } from '../Localization/localization.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { LightBoxComponent } from './components/LightBox/light-box.component';
import { PopupDialogComponent } from './components/PopupDialog/popup-dialog.component';


@NgModule({
    imports: [
        CommonModule,
        LocalizationModule,
        A11yModule,
        CommonBasicModule,
        ClickOutsideModule,
        MiscModule
    ],
    declarations: [
        DialogContainerComponent,
        LightBoxComponent,
        PopupDialogComponent
    ],
    exports: [
        DialogContainerComponent,
        LightBoxComponent,
        PopupDialogComponent
    ],
    providers: [
        CoreDialogService
    ]
})
export class CoreDialogsModule {
}
